import logoAllTrailsMarkSrc from 'components/icons/logo-alltrails-mark.svg';
import Typography from 'components/Typography';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import AltLoginsForm from 'components/AltLoginsForm';
import SectionDivider from 'components/shared/SectionDivider';
import { facebookHandler, appleHandler, googleHandler } from 'utils/OAuthHandlers';
import Button from '@alltrails/shared/denali/components/Button';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import useFormatMessage from 'hooks/useFormatMessage';
import TextButton from 'components/TextButton';
import TermsOfService from 'components/TermsOfService';
import { useDispatch } from 'react-redux';
import User from '@alltrails/shared/types/User';
import * as styles from './InitialSignUpScreen.module.scss';
import { setUser } from '../../userSlice';

const messages = defineMessages({
  createFreeAccount: {
    defaultMessage: 'Create a free account'
  }
});

const br = () => <br className={styles.mdVisible} />;
const span = (chunks: string) => <Typography color="green">{chunks}</Typography>;

type Props = {
  handleCreateAccountClick: () => void;
  handleLoginClick: () => void;
  onSuccess: () => void;
  redirectUrl?: string;
};

// Desktop: https://zpl.io/EmkzlLY
// Mobile: https://zpl.io/vMLlJgr

export default function InitialSignUpScreen({ handleCreateAccountClick, handleLoginClick, onSuccess, redirectUrl }: Props) {
  const {
    formattedDefaultMessages: { createFreeAccount }
  } = useFormatMessage(messages);

  const languageRegionCode = useLanguageRegionCode();
  const dispatch = useDispatch();

  function successCallback({ user }: { user: User }) {
    if (redirectUrl) {
      window.location.assign(redirectUrl);
    } else {
      dispatch(setUser(user));
      onSuccess();
      google.accounts.id.cancel();
    }
  }

  function handleGoogle(response: any) {
    googleHandler(
      response,
      languageRegionCode,
      successCallback,
      () => null,
      () => null
    );
  }

  function handleFacebook(response: any) {
    facebookHandler(
      response,
      languageRegionCode,
      successCallback,
      () => null,
      () => null
    );
  }

  function handleApple() {
    appleHandler();
  }

  return (
    <div className={styles.content}>
      <Typography component="div" mb="24">
        <img alt="" src={logoAllTrailsMarkSrc} />
      </Typography>
      <Typography component="div" mb="24" variant="xltitle">
        <FormattedMessage
          defaultMessage="To keep exploring trails,<br></br> log in or sign up <span>for free</span>"
          values={{
            br,
            span
          }}
        />
      </Typography>
      <div className={styles.grid}>
        <AltLoginsForm googleLoginHandler={handleGoogle} facebookLoginHandler={handleFacebook} appleLoginHandler={handleApple} />
        <SectionDivider>
          <FormattedMessage defaultMessage="or" />
        </SectionDivider>
        <Button
          text={createFreeAccount}
          className={styles.create}
          onClick={handleCreateAccountClick}
          testId="initial-sign-up-screen-create-account"
          variant="primary"
        />
        <Typography component="div" variant="subhead2">
          <FormattedMessage defaultMessage="Already have an account?" />{' '}
          <TextButton color="green" onClick={handleLoginClick}>
            <FormattedMessage defaultMessage="Log in" />
          </TextButton>
        </Typography>
        <TermsOfService />
      </div>
    </div>
  );
}
